import { AsyncStates } from "../../constants";
import { handleActions } from "redux-actions"
import { FetchExcelUploadActionTypes, GetPropertiesExtrapolationTypes, GetWorkOrderBayesianDataActionTypes, GetPredictExperimentActionTypes, GetPredictionHistoryListActionTypes, GetPredictionHistoryDetailsDataActionTypes, GetPredictionHistoryDetailFilterActionTypes, DeletePredictionHistoryActionTypes } from "../actions/extrapolation";

export type ExtrapolationState = {
    excelUploadError: string;
    excelUploadStatus: AsyncStates;
    getWorkOrderBayesianDataError: string;
    getWorkOrderBayesianDataStatus: AsyncStates;
    workOrderBayesianData: any;
    predictExprimentStatus: AsyncStates;
    predictExprimentError: string;
    predictExprimentData: any;
    propertiesData: any;
    propertiesStatus: AsyncStates;
    propertiesError: string;
    predictionHistoryList: any;
    predictionHistoryListStatus: AsyncStates;
    predictionHistoryListError: string;
    totalPredHistoryCount: number;
    predictionHistoryDetails: any;
    predictionHistoryDetailsStatus: AsyncStates;
    predictionHistoryDetailsError: string;
    predictionHistoryDetailFilter: any;
    predictionHistoryDetailFilterStatus: AsyncStates;
    predictionHistoryDetailFilterError: string;
    statusDeletePredictionIds: AsyncStates;
    deletePredictionHistoryError: string;
}

const defaultState: ExtrapolationState = {
    excelUploadError: "",
    excelUploadStatus: AsyncStates.INITIAL,
    getWorkOrderBayesianDataError: "",
    getWorkOrderBayesianDataStatus: AsyncStates.INITIAL,
    workOrderBayesianData: {},
    predictExprimentStatus: AsyncStates.INITIAL,
    predictExprimentError: "",
    predictExprimentData: {},
    propertiesData: {},
    propertiesStatus: AsyncStates.INITIAL,
    propertiesError: "",
    predictionHistoryList: [],
    predictionHistoryListStatus: AsyncStates.INITIAL,
    predictionHistoryListError: "",
    totalPredHistoryCount: 0,
    predictionHistoryDetails: {},
    predictionHistoryDetailsStatus: AsyncStates.INITIAL,
    predictionHistoryDetailsError: "",
    predictionHistoryDetailFilter: [],
    predictionHistoryDetailFilterStatus: AsyncStates.INITIAL,
    predictionHistoryDetailFilterError: "",
    statusDeletePredictionIds: AsyncStates.INITIAL,
    deletePredictionHistoryError: "",
}

const extrapolationReducer = handleActions<ExtrapolationState, any>(
    {
        [GetWorkOrderBayesianDataActionTypes.REQUEST]: (state) => ({
            ...state,
            getWorkOrderBayesianDataStatus: AsyncStates.LOADING,
            getWorkOrderBayesianDataError: "",
        }),
        [GetWorkOrderBayesianDataActionTypes.SUCCESS]: (state, action) => ({
            ...state,
            getWorkOrderBayesianDataStatus: AsyncStates.SUCCESS,
            getWorkOrderBayesianDataError: "",
            workOrderBayesianData: action.payload,
        }),
        [GetWorkOrderBayesianDataActionTypes.FAILURE]: (state, action) => ({
            ...state,
            getWorkOrderBayesianDataStatus: AsyncStates.ERROR,
            getWorkOrderBayesianDataError: action?.payload?.error,
        }),
        [GetWorkOrderBayesianDataActionTypes.CLEANUP]: (state) => ({
            ...state,
            getWorkOrderBayesianDataStatus: AsyncStates.INITIAL,
            getWorkOrderBayesianDataError: "",
            workOrderBayesianData: {},
        }),
        [GetPredictExperimentActionTypes.REQUEST]: (state) => ({
            ...state,
            predictExprimentStatus: AsyncStates.LOADING,
            predictExprimentError: "",
        }),
        [GetPredictExperimentActionTypes.SUCCESS]: (state, action) => ({
            ...state,
            predictExprimentStatus: AsyncStates.SUCCESS,
            predictExprimentError: "",
            predictExprimentData: action.payload,
        }),
        [GetPredictExperimentActionTypes.FAILURE]: (state, action) => ({
            ...state,
            predictExprimentStatus: AsyncStates.ERROR,
            predictExprimentError: action?.payload?.error,
        }),
        [GetPredictExperimentActionTypes.CLEANUP]: (state) => ({
            ...state,
            predictExprimentStatus: AsyncStates.INITIAL,
            predictExprimentError: "",
            predictExprimentData: {},
        }),
        [FetchExcelUploadActionTypes.REQUEST]: (state) => ({
            ...state,
            excelUploadStatus: AsyncStates.LOADING,
            excelUploadError: "",
        }),
        [FetchExcelUploadActionTypes.SUCCESS]: (state, action) => ({
            ...state,
            excelUploadStatus: AsyncStates.SUCCESS,
            excelUploadError: "",
        }),
        [FetchExcelUploadActionTypes.FAILURE]: (state, action) => ({
            ...state,
            excelUploadStatus: AsyncStates.ERROR,
            excelUploadError: action?.payload?.error,
        }),
        [GetPropertiesExtrapolationTypes.REQUEST]: (state) => ({
            ...state,
            propertiesStatus: AsyncStates.LOADING,
            propertiesError: "",
        }),
        [GetPropertiesExtrapolationTypes.SUCCESS]: (state, action) => ({
            ...state,
            propertiesStatus: AsyncStates.SUCCESS,
            propertiesError: "",
            propertiesData: action.payload,
        }),
        [GetPropertiesExtrapolationTypes.FAILURE]: (state, action) => ({
            ...state,
            propertiesStatus: AsyncStates.ERROR,
            propertiesError: action?.payload?.error,
        }),
        [GetPropertiesExtrapolationTypes.CLEANUP]: (state) => ({
            ...state,
            propertiesStatus: AsyncStates.INITIAL,
            propertiesError: "",
            propertiesData: {},
        }),
        [GetPredictionHistoryListActionTypes.REQUEST]: (state) => ({
            ...state,
            predictionHistoryListStatus: AsyncStates.LOADING,
            predictionHistoryListError: "",
        }),
        [GetPredictionHistoryListActionTypes.SUCCESS]: (state, action) => ({
            ...state,
            predictionHistoryListStatus: AsyncStates.SUCCESS,
            predictionHistoryListError: "",
            predictionHistoryList: action?.payload?.data,
            totalPredHistoryCount: action?.payload?.total
        }),
        [GetPredictionHistoryListActionTypes.FAILURE]: (state, action) => ({
            ...state,
            predictionHistoryListStatus: AsyncStates.ERROR,
            predictionHistoryListError: action?.payload?.error,
        }),
        [GetPredictionHistoryListActionTypes.CLEANUP]: (state) => ({
            ...state,
            predictionHistoryListStatus: AsyncStates.INITIAL,
            predictionHistoryListError: "",
            predictionHistoryList: [],
            totalPredHistoryCount: 0
        }),
        [GetPredictionHistoryDetailsDataActionTypes.REQUEST]: (state) => ({
            ...state,
            predictionHistoryDetailsStatus: AsyncStates.LOADING,
            predictionHistoryDetailsError: "",
        }),
        [GetPredictionHistoryDetailsDataActionTypes.SUCCESS]: (state, action) => ({
            ...state,
            predictionHistoryDetailsStatus: AsyncStates.SUCCESS,
            predictionHistoryDetailsError: "",
            predictionHistoryDetails: action?.payload,
        }),
        [GetPredictionHistoryDetailsDataActionTypes.FAILURE]: (state, action) => ({
            ...state,
            predictionHistoryDetailsStatus: AsyncStates.ERROR,
            predictionHistoryDetailsError: action?.payload?.error,
        }),
        [GetPredictionHistoryDetailsDataActionTypes.CLEANUP]: (state) => ({
            ...state,
            predictionHistoryDetailsStatus: AsyncStates.INITIAL,
            predictionHistoryDetailsError: "",
            predictionHistoryDetails: {},
        }),
        [GetPredictionHistoryDetailFilterActionTypes.REQUEST]: (state) => ({
            ...state,
            predictionHistoryDetailFilterStatus: AsyncStates.LOADING,
            predictionHistoryDetailFilterError: "",
        }),
        [GetPredictionHistoryDetailFilterActionTypes.SUCCESS]: (state, action) => ({
            ...state,
            predictionHistoryDetailFilterStatus: AsyncStates.SUCCESS,
            predictionHistoryDetailFilterError: "",
            predictionHistoryDetailFilter: action?.payload,
        }),
        [GetPredictionHistoryDetailFilterActionTypes.FAILURE]: (state, action) => ({
            ...state,
            predictionHistoryDetailFilterStatus: AsyncStates.ERROR,
            predictionHistoryDetailFilterError: action?.payload?.error,
        }),
        [GetPredictionHistoryDetailFilterActionTypes.CLEANUP]: (state) => ({
            ...state,
            predictionHistoryDetailFilterStatus: AsyncStates.INITIAL,
            predictionHistoryDetailFilterError: "",
            predictionHistoryDetailFilter: [],
        }),
        [DeletePredictionHistoryActionTypes.REQUEST]: (state) => ({
            ...state,
            statusDeletePredictionIds: AsyncStates.LOADING,
            deletePredictionHistoryError: "",
        }),
        [DeletePredictionHistoryActionTypes.SUCCESS]: (state, action) => ({
            ...state,
            statusDeletePredictionIds: AsyncStates.SUCCESS,
            deletePredictionHistoryError: "",
        }),
        [DeletePredictionHistoryActionTypes.FAILURE]: (state, action) => ({
            ...state,
            statusDeletePredictionIds: AsyncStates.ERROR,
            deletePredictionHistoryError: action?.payload?.error,
        }),
        [DeletePredictionHistoryActionTypes.CLEANUP]: (state) => ({
            ...state,
            statusDeletePredictionIds: AsyncStates.INITIAL,
            deletePredictionHistoryError: "",
        }),
    },
    defaultState
)


export default extrapolationReducer;